import { Injectable } from '@angular/core';
import { StudioConfigService } from './studio-config.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DateFormatService {
  // Map of country codes to date formats
  private countryDateFormats: { [key: string]: string } = {
    'US': 'MM/dd/yyyy', // United States: month/day/year
    'CA': 'yyyy-MM-dd', // Canada: year-month-day
    'GB': 'dd/MM/yyyy', // United Kingdom: day/month/year
    'AU': 'dd/MM/yyyy', // Australia: day/month/year
    'NZ': 'dd/MM/yyyy', // New Zealand: day/month/year
    'IE': 'dd/MM/yyyy', // Ireland: day/month/year
    'IN': 'dd/MM/yyyy', // India: day/month/year
    'ZA': 'yyyy/MM/dd', // South Africa: year/month/day
    'JP': 'yyyy/MM/dd', // Japan: year/month/day
    'CN': 'yyyy-MM-dd', // China: year-month-day
    'KR': 'yyyy-MM-dd', // South Korea: year-month-day
    'DE': 'dd.MM.yyyy', // Germany: day.month.year
    'FR': 'dd/MM/yyyy', // France: day/month/year
    'IT': 'dd/MM/yyyy', // Italy: day/month/year
    'ES': 'dd/MM/yyyy', // Spain: day/month/year
    'PT': 'dd/MM/yyyy', // Portugal: day/month/year
    'NL': 'dd-MM-yyyy', // Netherlands: day-month-year
    'BE': 'dd/MM/yyyy', // Belgium: day/month/year
    'SE': 'yyyy-MM-dd', // Sweden: year-month-day
    'NO': 'dd.MM.yyyy', // Norway: day.month.year
    'DK': 'dd-MM-yyyy', // Denmark: day-month-year
    'FI': 'dd.MM.yyyy', // Finland: day.month.year
    'RU': 'dd.MM.yyyy', // Russia: day.month.year
    'BR': 'dd/MM/yyyy', // Brazil: day/month/year
    'MX': 'dd/MM/yyyy'  // Mexico: day/month/year
  };

  // Map of country codes to date picker formats
  private owlDateTimeFormats: { [key: string]: any } = {
    'US': {
      dateFormat: 'MM/DD/YYYY',
      timeFormat: 'hh:mm A'
    },
    'GB': {
      dateFormat: 'DD/MM/YYYY',
      timeFormat: 'HH:mm'
    },
    // Default to international format for other countries
    'DEFAULT': {
      dateFormat: 'DD/MM/YYYY',
      timeFormat: 'HH:mm'
    }
  };

  constructor(private studioConfigService: StudioConfigService) {}

  /**
   * Get the appropriate date format for the configured country
   */
  getDateFormat(): Observable<string> {
    return this.studioConfigService.getCountryCode().pipe(
      map(countryCode => this.countryDateFormats[countryCode] || this.countryDateFormats['US'])
    );
  }

  /**
   * Get the appropriate Owl DateTime format for the configured country
   */
  getOwlDateTimeFormat(): Observable<any> {
    return this.studioConfigService.getCountryCode().pipe(
      map(countryCode => this.owlDateTimeFormats[countryCode] || this.owlDateTimeFormats['DEFAULT'])
    );
  }

  /**
   * Get the OwlDateTime format configuration for a specific country code
   */
  getOwlDateTimeFormatByCountry(countryCode: string): any {
    return this.owlDateTimeFormats[countryCode] || this.owlDateTimeFormats['DEFAULT'];
  }
}
